import Vue from 'vue';
import App from './App.vue';
// import Vuetify from  'vuetify'
import './plugins/vuetify';
import router from './router';
import store from '@/store';
import DEFINES from '@/defines';
//import './registerServiceWorker';
import i18n from './i18n';
import moment from 'moment';
var momentTz = require('moment-timezone');
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VueMeta from 'vue-meta';
var vueAwesomeCountdown = require('vue-awesome-countdown').default;
var VueCookie = require('vue-cookie');
import Snotify from 'vue-snotify';
import * as firebase from 'firebase';

import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)

import Print from 'vue-print-nb'
Vue.use(Print);

// Vue Tooltip
import VTooltip from 'v-tooltip';
import "@/plugins/tooltip.scss";
Vue.use(VTooltip);

// Vue Filters
import filters from './filters';

Vue.use(vueAwesomeCountdown);
Vue.use(VueMeta);
Vue.use(momentTz);

Vue.use(Snotify);
//Google analytics configuration for production env
require('@/analytics');
require('@/plugins/firebase')

import VideoBackground from 'vue-responsive-video-background-player'
 Vue.component('video-background', VideoBackground);

Vue.prototype.DEFINES = DEFINES;
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.momentTz = momentTz;
Vue.use(VueCookie);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
